import React, { Suspense, useEffect, useState } from "react";

import TabButton from "../../../../Components/common/TabButton/TabButton";
import Spinner from "../../../../Components/common/Spinner/Spinner";
import FilesInfo from "../../../../Components/PagesComponents/AnalysisReports/FilesInfo/FilesInfo";
import NetworkActivityMap from "../../../../Components/PagesComponents/AnalysisReports/NetworkActivityMap/NetworkActivityMap";
import MemoryBlock from "../../../../Components/PagesComponents/AnalysisReports/MemoryBlock/MemoryBlock";
import AndroidPlugins from "../../../../Components/PagesComponents/AnalysisReports/AndroidPlugins/AndroidPlugins";

import "./styles.scss";

const Crimes = React.lazy(() => import("./Tabs/Crimes/Crimes").then((r) => r));
const StaticCodeIssues = React.lazy(() =>
  import("./Tabs/StaticCodeIssues/StaticCodeIssues").then((r) => r),
);
const Permissions = React.lazy(() => import("./Tabs/Permissions/Permissions").then((r) => r));
const Matrix = React.lazy(() => import("../../Content/Tabs/Matrix/Matrix").then((r) => r));
const StaticInfo = React.lazy(() =>
  import("../../Content/Tabs/StaticInfo/StaticInfo").then((r) => r),
);

const AndroidContent = ({ staticResultsActive, setStaticResultsActive }) => {
  const [active, setActive] = useState("Possible Malicious Actions");

  useEffect(() => {
    if (staticResultsActive) {
      setActive("Static Results");
    }
  }, [staticResultsActive]);

  const onTitleClicked = (title) => {
    if (title !== "Static Results") {
      setStaticResultsActive(false);
    }
    setActive(title);
  };

  return (
    <div className="analysis-reports__table ">
      <div className="button-block">
        <TabButton title="Possible Malicious Actions" onClick={onTitleClicked} active={active} />
        <TabButton title="Static Code Issues" onClick={onTitleClicked} active={active} />
        <TabButton title="MITRE ATT&CK™ Matrix" onClick={onTitleClicked} active={active} />
        <TabButton title="Static Results" onClick={onTitleClicked} active={active} />
        <TabButton title="Permissions" onClick={onTitleClicked} active={active} />
      </div>
      {active === "Possible Malicious Actions" ? (
        <Suspense
          fallback={
            <div className="spinner-block border">
              <Spinner />
            </div>
          }>
          <Crimes />
        </Suspense>
      ) : active === "Static Code Issues" ? (
        <Suspense
          fallback={
            <div className="spinner-block border">
              <Spinner />
            </div>
          }>
          <StaticCodeIssues />
        </Suspense>
      ) : active === "Permissions" ? (
        <Suspense
          fallback={
            <div className="spinner-block border">
              <Spinner />
            </div>
          }>
          <Permissions />
        </Suspense>
      ) : active === "MITRE ATT&CK™ Matrix" ? (
        <Suspense
          fallback={
            <div className="spinner-block border">
              <Spinner />
            </div>
          }>
          <Matrix />
        </Suspense>
      ) : active === "Static Results" ? (
        <Suspense
          fallback={
            <div className="spinner-block border">
              <Spinner />
            </div>
          }>
          <StaticInfo />
        </Suspense>
      ) : null}
      <div className="block-network-map">
        <FilesInfo isStaticFindingsEnabled={false} />
        <NetworkActivityMap />
      </div>
      <AndroidPlugins />
      <div className="block-memory">
        <MemoryBlock isArtifactsEnabled={false} isAndroidAdditionalDetailsEnabled />
      </div>
    </div>
  );
};

export default AndroidContent;
